import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faCalendarAlt, faDollarSign, faHashtag, faPercentage, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';

class Crear extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        fecha_factura: '',
        fecha_entrega: '',
        fecha_vencimiento: '',
        estado_factura: '',
        consecutivo_fact: '',
        id_departamento: '',
        id_municipio: '',
        periodo_factura: '',
        id_contribuyente: '',
        acuerdo_municipal: '',
        tipo_cliente: '',
        liq_vencidas: '',
        valor_liq_vencidas: '',
        id_tipo_facturacion: '',
        tipo_facturacion: '',
        tarifa: '',
        valor_tarifa: '',
        valor_factura: '',
        id_comercializador: '',
        facturado_por: '',
        observaciones: '',
        contribuyentes: [],
        departamentosMunc: [],
        municipiosMunc: [],
        periodos: [],
        comercializadores: [],
        errores: []
    }
    cambioValor = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errores: [] })
    }
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const { fecha_factura, fecha_entrega, fecha_vencimiento, estado_factura, consecutivo_fact,
                id_departamento, id_municipio, periodo_factura, id_contribuyente, acuerdo_municipal,
                tipo_cliente, liq_vencidas, valor_liq_vencidas, id_tipo_facturacion, tipo_facturacion,
                tarifa, valor_tarifa, valor_factura, id_comercializador, facturado_por, observaciones
            } = this.state;
        var errores = [];
        if (!fecha_factura) { errores.push("error_fecha_factura"); }
        if (!fecha_entrega) { errores.push("error_fecha_entrega"); }
        if (!fecha_vencimiento) { errores.push("error_fecha_vencimiento"); }
        if (!estado_factura) { errores.push("error_estado_factura"); }
        if (!consecutivo_fact) { errores.push("error_consecutivo_fact"); }
        if (!id_departamento) { errores.push("error_id_departamento"); }
        if (!id_municipio) { errores.push("error_id_municipio"); }
        if (!periodo_factura) { errores.push("error_periodo_factura"); }
        if (!id_contribuyente) { errores.push("error_id_contribuyente"); }
        if (!acuerdo_municipal) { errores.push("error_acuerdo_municipal"); }
        if (!tipo_cliente) { errores.push("error_tipo_cliente"); }
        if (!liq_vencidas) { errores.push("error_liq_vencidas"); }
        if (!valor_liq_vencidas) { errores.push("error_valor_liq_vencidas"); }
        if (!tipo_facturacion) { errores.push("error_tipo_facturacion"); }
        if (!tarifa) { errores.push("error_tarifa"); }
        if (!valor_tarifa) { errores.push("error_valor_tarifa"); }
        if (!valor_factura) { errores.push("error_valor_factura"); }
        if (!id_comercializador) { errores.push("error_id_comercializador"); }
        if (!facturado_por) { errores.push("error_facturado_por"); }
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        var datosEnviar = {
            fecha_factura: fecha_factura,
            fecha_entrega: fecha_entrega,
            fecha_vencimiento: fecha_vencimiento,
            estado_factura: estado_factura,
            consecutivo_fact: consecutivo_fact,
            id_departamento: id_departamento,
            id_municipio: id_municipio,
            periodo_factura: periodo_factura,
            id_contribuyente: id_contribuyente,
            acuerdo_municipal: acuerdo_municipal,
            tipo_cliente: tipo_cliente,
            liq_vencidas: liq_vencidas,
            valor_liq_vencidas: valor_liq_vencidas,
            id_tipo_facturacion: id_tipo_facturacion,
            tipo_facturacion: tipo_facturacion,
            tarifa: tarifa,
            valor_tarifa: valor_tarifa,
            valor_factura: valor_factura,
            id_comercializador: id_comercializador,
            facturado_por: facturado_por,
            observaciones: observaciones,
            id_usuario: window.localStorage.getItem('idusuario')
        }
        Swal.showLoading();
        authAxios.post("fact_municipio/registrar", datosEnviar)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                if (datosRespuesta.data.Status) {
                    Swal.close();
                    Swal.fire(
                        'Facturación Municipio!',
                        datosRespuesta.data.msj,
                        'success'
                    )
                    this.props.history.push("/MasterFactMunicipio");
                } else {
                    Swal.close();
                    Swal.fire(
                        'Facturación Municipio!',
                        datosRespuesta.data.msj,
                        'error'
                    )
                }
            })
            .catch(console.log)
    }
    cargarMunicipios() {
        var id_departamento = document.getElementById('id_departamento').value;
        Swal.showLoading();
        authAxios.get("municipios_visitas/buscardepartamento/" + id_departamento)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, municipiosMunc: datosRespuesta.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    cargarContribuyentes() {
        Swal.showLoading();
        var id_departamento = document.getElementById("id_departamento").value;
        var id_municipio = document.getElementById("id_municipio").value;
        authAxios.get("contribuyentes/contribuyente_munc/" + id_departamento + "/" + id_municipio)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, contribuyentes: datosRespuesta.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    cargarInfoContribuyente() {
        Swal.showLoading();
        var id_contribuyente = document.getElementById("id_contribuyente").value;
        var ano_fact = document.getElementById("periodo_factura").value.substr(0, 4);
        authAxios.get("contribuyentes/contribuyente_info/" + id_contribuyente + "/" + ano_fact)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                let consecutivo_fact
                this.setState({ datosCargados: true, load: '' });
                if (id_contribuyente.length === 1) {
                    consecutivo_fact = "0" + datosRespuesta.data.resultado.ID_CONTRIBUYENTE + "" +
                                               document.getElementById("periodo_factura").value.substr(4, 2) + "" +
                                               document.getElementById("periodo_factura").value.substr(0, 4) + "-" +
                                               datosRespuesta.data.resultado_fact_espc;
                } else {
                    consecutivo_fact = datosRespuesta.data.resultado.ID_CONTRIBUYENTE + "" +
                                               document.getElementById("periodo_factura").value.substr(4, 2) + "" +
                                               document.getElementById("periodo_factura").value.substr(0, 4) + "-" +
                                               datosRespuesta.data.resultado_fact_espc;
                }
                this.setState({ id_tipo_facturacion: datosRespuesta.data.resultado.ID_TIPO_FACTURACION,
                                acuerdo_municipal: datosRespuesta.data.resultado.ACUERDO_MCPAL,
                                tarifa: datosRespuesta.data.resultado.TARIFA, consecutivo_fact: consecutivo_fact });
                switch (datosRespuesta.data.resultado.ID_TIPO_FACTURACION) {
                    case 1:
                        document.getElementById("tipo_facturacion").value = "CONSUMO";
                        this.setState({ tipo_facturacion: "CONSUMO", valor_tarifa: '', valor_factura: '' });
                        break;
                    case 2:
                        document.getElementById("tipo_facturacion").value = "SALARIOS";
                        this.setState({ tipo_facturacion: "SALARIOS",
                                        valor_factura: (datosRespuesta.data.resultado.TARIFA * datosRespuesta.data.resultado_smlv.SALARIO_MINIMO),
                                        valor_tarifa: datosRespuesta.data.resultado_smlv.SALARIO_MINIMO });
                        break;
                    case 3:
                        document.getElementById("tipo_facturacion").value = "UVT";
                        this.setState({ tipo_facturacion: "UVT",
                                        valor_factura: (datosRespuesta.data.resultado.TARIFA * datosRespuesta.data.resultado_uvt.UVT),
                                        valor_tarifa: datosRespuesta.data.resultado_uvt.UVT });
                        break;
                    case 4:
                        document.getElementById("tipo_facturacion").value = "COMERCIAL";
                        this.setState({ tipo_facturacion: "COMERCIAL", valor_tarifa: '', valor_factura: '' });
                        break;
                }
                Swal.close();
            })
            .catch(console.log);
    }
    calcularValorTarifa = () => {
        var tarifa = document.getElementById("tarifa").value;
        var valor_tarifa = document.getElementById("valor_tarifa").value;
        this.setState({ valor_factura: (Math.round((tarifa / 100) * valor_tarifa)) });
        document.getElementById('valor_factura').value = (Math.round((tarifa / 100) * valor_tarifa));
    }
    crearConsecutivoFact = () => {
        var id_contribuyente = document.getElementById("id_contribuyente").value;
        var consecutivo_fact = document.getElementById("consecutivo_fact").value;
        if (id_contribuyente.length === 1) {
            consecutivo_fact = "0" + id_contribuyente + "" +
                                     document.getElementById("periodo_factura").value.substr(4, 2) + "" +
                                     document.getElementById("periodo_factura").value.substr(0, 4) + "-" +
                                     consecutivo_fact.split('-')[1];
        } else {
            consecutivo_fact = id_contribuyente + "" +
                                       document.getElementById("periodo_factura").value.substr(4, 2) + "" +
                                       document.getElementById("periodo_factura").value.substr(0, 4) + "-" +
                                       consecutivo_fact.split('-')[1];
        }
        document.getElementById("consecutivo_fact").value = consecutivo_fact;
        this.setState({ consecutivo_fact: consecutivo_fact });
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("departamentos_visitas/index/0")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, departamentosMunc: datosRespuesta.data.data, load: '' });
            })
            .catch(console.log);
        authAxios.get("fact_municipio/periodos_fact")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, periodos: datosRespuesta.data, load: '' });
            })
            .catch(console.log);
        authAxios.get("comercializadores/index/0")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, comercializadores: datosRespuesta.data.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    render() {
        const { fecha_factura, fecha_entrega, fecha_vencimiento, estado_factura, consecutivo_fact,
                id_departamento, id_municipio, periodo_factura, id_contribuyente, acuerdo_municipal,
                tipo_cliente, liq_vencidas, valor_liq_vencidas, id_tipo_facturacion, tipo_facturacion,
                tarifa, valor_tarifa, valor_factura, id_comercializador, facturado_por, observaciones,
                periodos, departamentosMunc, municipiosMunc, contribuyentes, comercializadores
            } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                <b>REGISTRO DE FACTURAS MUNICIPIO</b>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos}>
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="fecha_factura">Fecha Factura</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="date" name="fecha_factura" id="fecha_factura" value={fecha_factura}
                                                            className={((this.verificarError("error_fecha_factura")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="FECHA FACTURA" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Seleccione la Fecha Factura</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="fecha_entrega">Fecha Entrega</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="date" name="fecha_entrega" id="fecha_entrega" value={fecha_entrega}
                                                            className={((this.verificarError("error_fecha_entrega")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="FECHA ENTREGA" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Seleccione la Fecha Entrega</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="fecha_vencimiento">Fecha Vencimiento</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="date" name="fecha_vencimiento" id="fecha_vencimiento" value={fecha_vencimiento}
                                                            className={((this.verificarError("error_fecha_vencimiento")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="FECHA VENCIMIENTO" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Seleccione la Fecha Entrega</small>
                                                </div>
                                                <div className='col-md-3'>
                                                    <label htmlFor="periodo_factura">Periodo Factura</label>
                                                    <select name="periodo_factura"
                                                        id="periodo_factura"
                                                        className={((this.verificarError("error_periodo_factura")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={(e) => {
                                                            this.cambioValor(e)
                                                            this.crearConsecutivoFact(e);
                                                        }}>
                                                        <option value="">Seleccione el Periodo Factura</option>
                                                        {
                                                            periodos.map((itemPeriodos) => (
                                                                <option key={itemPeriodos.ID_TABLA} value={itemPeriodos.ANO_FACTURA + "" + itemPeriodos.MES_FACTURA}>{itemPeriodos.PERIODO} - {itemPeriodos.ANO_FACTURA}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Periodo Factura</small>
                                                </div>
                                                <div className='col-md-3'>
                                                    <label htmlFor="estado_factura">Estado Factura</label>
                                                    <select name="estado_factura"
                                                        id="estado_factura"
                                                        className={((this.verificarError("error_estado_factura")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione el Estado Factura</option>
                                                        <option value="1">ENTREGADO</option>
                                                        <option value="2">PENDIENTE DE ENVÍO</option>
                                                        <option value="3">RECLAMADA</option>
                                                        <option value="4">ANULADA</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Estado Factura</small>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN MUNICIPIO / CONTRIBUYENTE</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className='col-md-3'>
                                                    <label htmlFor="id_departamento">Departamento</label>
                                                    <select name="id_departamento"
                                                        id="id_departamento"
                                                        className={((this.verificarError("error_id_departamento")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={e => {
                                                            this.cargarMunicipios(e);
                                                            this.cambioValor(e)
                                                        }}>
                                                        <option value="">Seleccione el Departamento</option>
                                                        {
                                                            departamentosMunc.map((itemDepartamentosMunc) => (
                                                                <option key={itemDepartamentosMunc.ID_TABLA} value={itemDepartamentosMunc.ID_DEPARTAMENTO}>{itemDepartamentosMunc.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Departamento</small>
                                                </div>
                                                <div className='col-md-3'>
                                                    <label htmlFor="id_municipio">Municipio</label>
                                                    <select name="id_municipio"
                                                        id="id_municipio"
                                                        className={((this.verificarError("error_id_municipio")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={(e) => {
                                                            this.cargarContribuyentes(e);
                                                            this.cambioValor(e)
                                                        }}>
                                                        <option value="">Seleccione el Municipio</option>
                                                        {
                                                            municipiosMunc.map((itemMunicipiosMunc) => (
                                                                <option key={itemMunicipiosMunc.ID_TABLA} value={itemMunicipiosMunc.ID_MUNICIPIO}>{itemMunicipiosMunc.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Municipio</small>
                                                </div>
                                                <div className='col-md-6'>
                                                    <label htmlFor="id_contribuyente">Contribuyente</label>
                                                    <select name="id_contribuyente"
                                                        id="id_contribuyente"
                                                        className={((this.verificarError("error_id_contribuyente")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={(e) => {
                                                            this.cargarInfoContribuyente(e);
                                                            this.cambioValor(e)
                                                        }}>
                                                        <option value="">Seleccione el Contribuyente</option>
                                                        {
                                                            contribuyentes.map((itemContribuyentes) => (
                                                                <option key={itemContribuyentes.ID_CONTRIBUYENTE} value={itemContribuyentes.ID_CONTRIBUYENTE}>{itemContribuyentes.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Contribuyente</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-6">
                                                    <label htmlFor="acuerdo_municipal">Acuerdo Municipal</label>
                                                    <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_acuerdo_municipal")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="acuerdo_municipal" id="acuerdo_municipal" value={acuerdo_municipal} placeholder="ACUERDO MUNICIPAL" aria-describedby="helpId" onChange={this.cambioValor} readOnly />
                                                    <small id="helpId" className="invalid-feedback">Digite el Acuerdo Municipal</small>
                                                </div>
                                                <div className='col-md-3'>
                                                    <label htmlFor="tipo_cliente">Tipo Cliente</label>
                                                    <select name="tipo_cliente"
                                                        id="tipo_cliente"
                                                        className={((this.verificarError("error_tipo_cliente")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione el Tipo Cliente</option>
                                                        <option value="1">ANTIGUO</option>
                                                        <option value="2">NUEVO</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Tipo Cliente</small>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN TIPO FACTURACIÓN / VALORES FACTURA</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className="row g-3">
                                                <div className="col-md-2">
                                                    <label htmlFor="consecutivo_fact">Consecutivo Factura</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="consecutivo_fact" id="consecutivo_fact" value={consecutivo_fact}
                                                            className={((this.verificarError("error_consecutivo_fact")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Consecutivo Fact." aria-describedby="helpId"
                                                            onChange={this.cambioValor} readOnly
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Consecutivo Factura</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className="row g-3">
                                                <div className="col-md-2">
                                                    <label htmlFor="liq_vencidas">Liq. Vencidas</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="liq_vencidas" id="liq_vencidas" value={liq_vencidas}
                                                            className={((this.verificarError("error_liq_vencidas")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Liq. Vencidas" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite las Liq. Vencidas</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="valor_liq_vencidas">Valor Liq. Vencidas</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="valor_liq_vencidas" id="valor_liq_vencidas" value={valor_liq_vencidas}
                                                            className={((this.verificarError("error_valor_liq_vencidas")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Valor Liq. Vencidas" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Valor Liq. Vencidas</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="tipo_facturacion">Tipo Facturación</label>
                                                    <input type="hidden" name='id_tipo_facturacion' id='id_tipo_facturacion' value={id_tipo_facturacion} />
                                                    <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_tipo_facturacion")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="tipo_facturacion" id="tipo_facturacion" value={tipo_facturacion} placeholder="TIPO FACTURACIÓN" aria-describedby="helpId" onChange={this.cambioValor} readOnly />
                                                    <small id="helpId" className="invalid-feedback">Digite el Tipo Facturación</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="tarifa">Tarifa</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={id_tipo_facturacion === 1 ? faPercentage : faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="tarifa" id="tarifa" value={tarifa}
                                                            className={((this.verificarError("error_tarifa")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Tarifa" aria-describedby="helpId"
                                                            onChange={this.cambioValor} readOnly
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite la Tarifa</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="valor_tarifa">Valor Tarifa</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="valor_tarifa" id="valor_tarifa" value={valor_tarifa}
                                                            className={((this.verificarError("error_valor_tarifa")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Valor Tarifa" aria-describedby="helpId"
                                                            onChange={(e) => {
                                                                this.cambioValor(e);
                                                                this.calcularValorTarifa(e);
                                                            }}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Valor Tarifa</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="valor_factura">Valor Factura</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="valor_factura" id="valor_factura" value={valor_factura}
                                                            className={((this.verificarError("error_valor_factura")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Valor Factura" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Valor Factura</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className="row g-3">
                                                <div className='col-md-6'>
                                                    <label htmlFor="id_comercializador">Comercializadora</label>
                                                    <select name="id_comercializador"
                                                        id="id_comercializador"
                                                        className={((this.verificarError("error_id_comercializador")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione la Comercializadora</option>
                                                        {
                                                            comercializadores.map((itemComercializadores) => (
                                                                <option key={itemComercializadores.ID_COMERCIALIZADOR} value={itemComercializadores.ID_COMERCIALIZADOR}>{itemComercializadores.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione la Comercializadora</small>
                                                </div>
                                                <div className='col-md-3'>
                                                    <label htmlFor="facturado_por">Facturado Por</label>
                                                    <select name="facturado_por"
                                                        id="facturado_por"
                                                        className={((this.verificarError("error_facturado_por")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione Facturado Por</option>
                                                        <option value="1">COMERCIALIZADOR</option>
                                                        <option value="2">CUENTA DE COBRO</option>
                                                        <option value="3">RESOLUCIÓN</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione Facturado Por</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-12">
                                                    <label htmlFor="observaciones">Observaciones</label>
                                                    <textarea style={{ resize: 'none', textTransform: 'uppercase' }} className='form-control form-control-sm' id="observaciones" name="observaciones" rows='3' onChange={this.cambioValor} aria-describedby="helpId"></textarea>
                                                    <small id="helpId" className="invalid-feedback">Digite las Observaciones</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-success btn-sm"><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Crear Fact. Municipio</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterFactMunicipio"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Crear;